import type { EntryFieldTypes } from 'contentful';

import { contentfulClient } from '@/apis/contentful';

interface ReleaseNoteSkeleton {
  contentTypeId: 'releaseNotes';
  fields: {
    releaseTitle: EntryFieldTypes.Text;
    releaseDescription: EntryFieldTypes.RichText;
    releaseMedia: EntryFieldTypes.AssetLink;
  };
}

export function getReleaseNotes() {
  return contentfulClient.withoutUnresolvableLinks.getEntries<ReleaseNoteSkeleton>({
    content_type: 'releaseNotes',
    order: ['-sys.createdAt'],
  });
}
